import { parse } from 'qs';
import React, { useEffect, useRef } from 'react';
import { history } from 'src/store/history';
import styles from './JobPost.scss';

// Greenhouse needs a hardcoded id for the iframe container
const GREENHOUSE_DIV_ID = 'grnhse_app';

export const JobPost = () => {
  const iframeContainerRef = useRef(null);

  const { gh_jid: jobId } = parse(history.location.search, { ignoreQueryPrefix: true });

  useEffect(() => {
    // make sure that the container div has rendered before loading the iframe
    if (iframeContainerRef.current) {
      window.Grnhse.Iframe.load(jobId as string);
    }
  }, [history.location.search, iframeContainerRef.current]);

  return (
    <div className={styles.container}>
      <div ref={iframeContainerRef} id={GREENHOUSE_DIV_ID} className={styles.jobPost} />
    </div>
  );
};
